import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

type ExpenseIconProps = SvgIconProps;

export const ExpenseIcon: React.FC<ExpenseIconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path
      d="M17 4H7C5.9 4 5 4.9 5 6v12c0 1.1 0.9 2 2 2h10c1.1 0 2-0.9 2-2V6c0-1.1-0.9-2-2-2z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M16 7H8v3h8V7z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9 12h2v2H9v-2zm4 0h2v2h-2v-2zm-4 3h2v2H9v-2zm4 0h2v2h-2v-2z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 5.5c1.1 0 2 0.9 2 2s-0.9 2-2 2-2-0.9-2-2 0.9-2 2-2m0-1c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3z"
      fill="none"
      stroke="white"
      strokeWidth="0.5"
    />
    <path
      d="M12 6v3M11 7h2"
      stroke="white"
      strokeWidth="0.75"
      strokeLinecap="round"
    />
  </SvgIcon>
);